import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { sectionFactory } from '../SectionFactory';

interface IModalProps {
  open: boolean
  className?: string;
  position?: 'fixed' | 'relative'; // Add a position prop with allowed values
  width?: string;
}

export class Modal extends React.Component<IModalProps, {}> {
  componentWillMount() {
    this.openOrCloseBasedOnProps(this.props)
  }

  componentWillReceiveProps(nextProps: IModalProps) {
    this.openOrCloseBasedOnProps(nextProps)
  }

  openOrCloseBasedOnProps(props: IModalProps) {
    const $modalElem = $(ReactDOM.findDOMNode(this.refs.theModal))
    $modalElem.modal({ dismissible: false })

    if (props.open) {
      $modalElem.modal('open')
    } else {
      $modalElem.modal('close')
    }
  }

  render() {
    const classNames = ['modal']

    if (this.props.className) {
      classNames.push(this.props.className);
    }
    const style: React.CSSProperties = {
      position: this.props.position || 'fixed',
      ...(this.props.width && { width: this.props.width }), // Add width if provided
    };
    return (
      <section className={classNames.join(' ')} ref="theModal" style={style}>
        {this.props.children}
      </section>
    );
  }
}

const ModalContent = sectionFactory('modal-content')
const ModalFooter = sectionFactory('modal-footer')

export {
  ModalContent,
  ModalFooter
}
